import React from 'react';
import moment from 'moment';
import 'moment-timezone';

import EmbeddedTimelineEvent from 'components/layout/EmbeddedTimelineEvent';

import IntlDate from 'components/layout/IntlDate';
import IntlDateRelative from 'components/layout/IntlDateRelative';

class OrderTimelineContent extends React.Component {
  render() {
    const { entity } = this.props;

    const momentWeekAgo = moment()
      .subtract(7, 'days')
      .startOf('day');

    return (
      <div>
        <div class="timeline-container left no-margin" style={{ width: '100%' }}>
          <section class="timeline line-grey no-margin p-b-0">
            {entity.getTimeline().map(event => {
              const eventDate = moment(event.getCdate()).isAfter(momentWeekAgo) ? (
                <IntlDateRelative date={event.getCdate()} />
              ) : (
                <IntlDate date={event.getCdate()} />
              );

              return <EmbeddedTimelineEvent date={eventDate} event={event} key={event.getId()} />;
            })}
          </section>
        </div>
      </div>
    );
  }
}
OrderTimelineContent.defaultProps = {
  timezone: 'UTC',
};

export default OrderTimelineContent;
